export const prerenderReady: Promise<void> = (
  document as { prerendering?: boolean }
).prerendering
  ? new Promise<void>((resolve) => {
      document.addEventListener(
        "prerenderingchange",
        () => {
          resolve();
        },
        { once: true },
      );
    })
  : Promise.resolve();
